const ptBr = {
  rules: {
    cpfLabel: "Fill in the CPF",
    passwordLabel: "Password cannot be empty",
    passwordLabelJustNumbers: "Password must only contain numbers.",
    passwordLabel2EqualNumbers:
      "Password cannot have 2 equal numbers in a row.",
    passwordLabel3EqualNumbers: "Password cannot have 3 sequential numbers.",
    passwordMin6Characteres: "Password must have 6 numbers.",
    emailLabel: "Fill in the email",
    emailLabelInvalid: "Invalid email.",
    cepLabel: "Fill in the zip code",
    invalidCepLabel: "Invalid zip code",
    estadoCivilLavel: "Marital Status is mandatory.",
    estadoCivilComNomeLabel:
      "It is not possible to change the Name without changing the Marital Status.",
    comprovanteLabel: "Proof is required.",
    telefoneInvalidoLabel: "Invalid phone",
    telefoneMaiorQueZeroLabel: "Phone cannot start with zero.",
    celularInvalidoLabel: "Invalid cell phone",
    celularMaiorQueZeroLabel: "Mobile cannot start with zero.",
    nomeObrigatorioLabel: "Name is required.",
    logradouroObrigatorioLabel: "Public place is mandatory.",
    ufObrigatorioLabel: "UF is mandatory.",
    grauInstrucaoObrigatorio: "Education degree is mandatory.",
    cidadeLabel: "City ​​is mandatory",
    matriculaLabel: "Certificate registration is mandatory.",
    observacaoLabel: "Note is mandatory.",
    comprovanteLabel: "Proof is required.",
    dataLabel: "Fill in the date.",
    dataInvalidaLabel: "Invalid date.",
    perguntaLabel: "This question is mandatory",
  },
  screen: {
    login: {
      contact: `We identified in our database that there is already a record with this CPF, however there is no password provided for this access.
      Please contact our company's HR at (37) 3286 - 2600 so that your registration can be updated and a password implemented in your registration.
      Thanks!`,
      messageCardLeft:
        "Welcome to the Employee Site, an easy and practical way to access your information, vouchers and guidance.",
      serviceNotFound: "Unavailable service",
      form1: {
        title: "Site Access",
        label:
          "To access the Employee Site, just inform your CPF and password!",
        passwordLabel: "Password",
        rememberLabel: "Remember me",
        btnLoginLabel: "Log in",
      },
      dialog1: {
        title: "Warning!",
        askMessagePassword: "How do you want to recover your password?",
        btnChangePasswordLabel: "CHANGE PASSWORD",
        btnCancelLabel: "CANCEL",
        btnSendLabel: "SEND",
        smsOK: "WhatsApp sent successfully!",
        smsError: "Oops... Unable to send the WhatsApp!",
        emailOK: "Email successfully sent!",
        emailError: "Oops... Unable to send E-mail!",
        passwordRecoveryError:
          "No password recovery option available. Contact the Human Resources department.",
        passwordOptionsRecovery: "Available options for password recovery: \n",
        phoneNotValid:
          "A valid phone number was not found in your registration.",
        smsNumber:
          "You can retrieve your password via an WhatsApp sent to the number ",
        noSmsNumber: "Number not found",
        emailNotFound:
          "A valid email address was not found in your registration.",
        emailNumber:
          "You can retrieve your password through an email sent to the address ",
        emailAndNumberNotFound:
          "No password recovery options available. Contact the company.",
        wrongPass: "Invalid password",
        wrongLogin: "Unable to login. \n ",
        cpfNotFound:
          "We have identified that the CPF informed is not in the database, please check the information provided.",
        passNotFound:
          "We identified that the CPF informed does not have a password registered in the system, please contact the company.",
        personNotFound:
          "We identified that the CPF informed is not linked to any employee registered in the system. Please check the information provided or contact the company.",
      },
      dialog2: {
        title: "Change Password!",
        message:
          "You have the default access password, For your safety change your password!!!",
        btnNewPasswordLabel: "New Password",
        btnCancelLabel: "Close",
        btnUpdateLabel: "Update",
      },
    },
    cgiCardDependente: {
      btnBenefits: "Benefits",
      benefits: "Benefits",
      btnClose: "Close",
    },
    footer: {
      name: "Employee Site",
      version: "Version",
    },
    navDrawerRight: {
      wellcome: "Welcome",
      user: "User",
      btnLogout: "Log out",
    },
    toolbar: {
      wellcome: "Welcome",
      start: "Home",
      imageAlt: "Profile picture",
      btnChangePass: "Change Password",
      btnWarnings: "Warnings",
      showAllWarnigs: "View all notices.",
      btnLogout: "Log out",
      labelChangePass: "New Password",
      passUpdatedOK: "Password changed successfully!",
      passUpdatedWrong: "Unable to change password",
    },
    formDadosCadastrais: {
      nameLavel: "Name",
      phoneLabel: "Telephone",
      celLavel: "Cell phone",
      emailLabel: "E-mail",
      logradouroLabel: "Public place",
      enderecoLabel: "Address",
      numeroLabel: "Number",
      complementoLabel: "Complement",
      bairroLabel: "Neighborhood",
      cidadeLabel: "City",
      estadoCivilLabel: "Marital status",
      conjugeLabel: "Spouse",
      grauInstrucaoLabel: "Level of Education",
      observacaoLabel: "Observation",
      comprovanteLabelNome: 'Proof of name change (Certificate)',
      comprovanteLabelInfoNome:
        'Attach in this field the certificate that proves the name change!',        
      comprovanteLabelEndereco: 'Proof of address',
      comprovanteLabelInfoEndereco:
        'Attach a proof of Address in this field (electricity, water bill, etc.)',                
      comprovanteLabelEstadoCivil: 'Proof of change of marital status (Certificate)',
      comprovanteLabelInfoEstadoCivil:
        'Attach proof of marital status change in this field!',                        
      comprovanteLabelGrauInstrucao: 'Proof of Education',
      comprovanteLabelInfoGrauInstrucao: 
        'Attach proof of schooling in this field (diploma, certificate, etc.)',
      comprovanteLabelImagem: 'PHOTO (new image for registration)',
      comprovanteLabelInfoImagem:
        'If you wish, attach a new image!',                                                
      btnCancelar: "Cancel",
      btnVoltar: "Come back",
      btnGravar: "Record",
      btnAvancar: "Next",
      error01Label:
        "It is necessary to modify at least one field to request a registration change.",
      error02Label:
        "Your request to change your registration data has been successfully received. \nSoon it will be analyzed by those responsible.",
      error03Label: "Error in Uploading proof of Registration Update.",
      error04Label:
        "Your request for alteration of registration data cannot be completed because it was not possible to send the receipt, please contact the company.",
      error05Label:
        "Your request to change your registration data has been successfully received. \nBut it was not possible to send the receipt, please contact the company.",
      error06Label: "It was not possible to request the registration update.",
    },
    formDependenteResponsivo: {
      nomeLabel: "Name",
      sexoLabel: "Gender",
      masculinoLabel: "Masculine",
      femininoLabel: "Feminine",
      grauDependenciaLabel: "Dependence Degree",
      cpfLabel: "CPF",
      nascimentoLabel: "Birth",
      nomePaiLabel: "Father's name",
      nomeMaeLabel: "Mother's name",
      cidadeLabel: "City",
      numCeridaoLabel: "Birth certificate number",
      livroLabel: "Book",
      folhaLabel: "Sheet",
      matriculaCertidaoLabel: "Certificate enrollment",
      dataCertidaoLabel: "Certificate date",
      estudanteLabel: "Student",
      necessidadesEspeciaisLabel: "Special Needs Holder",
      tipoNecessidadesEspeciaisLabel: "Special Need Type",
      observacaoLabel: "Observation",
      comprovanteLabel: "Proof",
      btnCancelar: "Cancel",
      btnVoltar: "Come back",
      btnGravar: "Record",
      btnAvancar: "Next",
      error01Label:
        "Your request to add a dependent has been successfully received. It will soon be analyzed by those responsible.",
      error02Label: "Error Uploading Dependent Voucher.",
      error03Label:
        "Your request for inclusion of a dependent cannot be completed because it was not possible to send the proof, please contact the company.",
      error04Label:
        "Your request to add a dependent has been successfully received. However, it was not possible to send the receipt, please contact the company.",
      error05Label: "It was not possible to request the registration update.",
    },
    avaliacaoClima: {
      descricaoLabel: "Description",
      naoSeAplica: "That question doesn't apply to me.",
    },
    avisos: {
      tituloLabel: "Warnings",
      possuiAnexosLavel: "It has attachments.",
      naoTemAvisosLabel: "You still don't have any notices.",
    },
    beneficios: {
      tituloLabel: "Benefits",
      table01: {
        header01: "Description",
        header02: "Company Name",
        header03: "Month Value",
        header04: "Accumulated value of the year",
      },
      error01Label: "No data available",
    },
    comprasVarejo: {
      tituloLabel: "Retail Purchases",
      error01Label: "No data available",
      table01: {
        header01: "Sale Date",
        header02: "Invoice",
        header03: "Value",
      },
    },
    comprovantes: {
      tituloLabel: "Receipts",
      string001: "Ref:",
      string002: "Receipt of",
      string003: "available",
      string004: "PRINT",
      string005: "Print the proof in PDF.",
      string006: "Earnings",
      string007: "Discounts",
      string008: "Liquid",
      string009: "Details",
      string010: "Close",
      string011: 'Base FGTS',
      string012: 'Value FGTS',
    },
    dadosCadastrais: {
      string001: "Personal data",
      string002: "Contractual Data",
      string003: "Update Registration",
      string004: "Benefits",
      string005: "Close",
      string006: "Warning!",
      string007: "Phone",
      string008: "Cell phone",
      string009: "E-mail",
      string010: "Marital status",
      string011: "Education degree",
      string012: "Company",
      string013: "CNPJ",
      string014: "Office",
      string015: "Unit",
      string016: "Admission",
      string017: "Wage",
      string018: "Supervisor",
      table01: {
        header01: "Type",
        header02: "Description",
        header03: "Field 2",
        header04: "Field 3",
        header05: "Field 4",
      },
      error001:
        "There is a pending registration data update request, wait for the review to be completed and try again.",
      error002:
        "It was not possible to update your registration data. Please try again later or contact the company.",
    },
    dependentes: {
      string001: "Dependents",
      string002: "Add Dependent",
      string003: "Warning!",
    },
    error404: {
      string001: "Page not found.",
      string002: "Home page",
    },
    espelhoDoPonto: {
      string001: "Point Mirror",
      string002: "Ref:",
      string003: "Receipt of",
      string004: "Point Mirror",
      string005: "Available",
      string006: "PRINT",
      string007: "Print the proof in PDF.",
    },
    faleComRH: {
      string001: "#TalkToHR",
      string002: "Reasons",
      string003: "Request",
      string004: "Describe the request",
      string005: "SEND",
      string006: "Data sent successfully!",
      string007: 'Attachment',
      string008: 'Historic',
    },
    home: {
      string001: "Capabilities",
      string002: "Statistics",
      string003: "Some statistics",
      string004: "of augmentation",
      string005: "Updated 4 minutes ago",
      string006: "Main Statistics",
      string007: "Updated 10 minutes ago",
      string008: "Employee Site",
      string009: "Receipts",
      string010: "Report income",
      string011: "Registration data",
      string012: "Dependents",
      string013: "Warnings",
      string014: "Mobile telephony",
      string015: "Retail Purchases",
      string016: "Point and PIP",
      string017: "Point Mirror",
      string018: "Benefits",
      string019: "Assessments and Surveys",
      string020: "#TalkToHR",
      string021: "Point markings",
      string022: 'Retail',
      string023: 'Employee Handbook',
      string024: 'vacations schedule',
      string025: 'Signed Documents',
      string026: 'Point Adjustment',
      string027: 'Internal Opportunities',
      string028: 'Restaurant Reservation',
      string029: 'Meal ticket',
      string031: 'Punctuality'
    },
    informesRendimentos: {
      string001: "Report income",
      string002: "Ref:",
      string003: "PRINT",
      string004: "Print the proof in PDF.",
      string005: "Income report not found",
      string006: "Available Income Report",
      string007: "Unavailable Income Report",
    },
    marcacoesPonto: {
      string001: "Point markings",
      string002: "Employee Code",
      string003: "Unit",
      string004: "Office",
      table01: {
        header01: "Date",
        header02: "Weekday",
        header03: "Schedule",
        header04: "Tags",
      },
      string005: 'Overtime 50%',
      string006: 'Overtime 100%',
      string007: 'Justified absences',
      string008: 'Unjustified  absences',
      string009: 'Overtime 60%',
      string010: 'Hours Bank Balance',
    },
    pip: {
      string001: "Point and PIP",
      string002: "Details",
      string003: "January",
      string004: "February",
      string005: "March",
      string006: "April",
      string007: "May",
      string008: "June",
      string009: "July",
      string010: "August",
      string011: "September",
      string012: "October",
      string013: "November",
      string014: "December",
      string015: "Average",
      string016: "Final grade",
      string017: "Occurrence date",
      string018: "The amount",
    },
    telefonia: {
      string001: "Mobile telephony",
      string002: "Initial date",
      string003: "Final date",
      table01: {
        header01: "Date",
        header02: "Observation",
      },
    },
    cartilha: {
      string001: 'Rules/News to the Employee',
      string002: 'PRINT OUT',
    },        
    programacao: {
      string001: 'Vacations schedule',
    },
    documentos: {
      string001: 'Documents Signed/To be Electronically Signed',
      string002: 'PRINT OUT',
      string003: 'To sign',
    },
    agendaAvaliacao: {
      string001: 'Pending Reviews',
      string002: 'To respond',
    },
    inclusaoPonto: {
      string001: 'Point Adjustment Request',
    },
    oportunidades: {
      string001: 'List of internal opportunities',
    },
    reserva: {
      string001: 'Restaurant Reservation',
    },
    valerefeicao: {
      string001: 'Meal ticket',
      string002: 'Initial date',
      string003: 'Final date',
      table01: {
        header01: 'Situation',
        header02: 'Event',
        header03: 'Description',
        header04: 'Competence',
        header05: 'Value',
      },
    },
    pontoTeletex: {
      string001: 'Inclusion of Marking',
      string002: 'Exclusion of Marking',
      string003: 'Hours Not Worked (HNT)',
      string004: 'Request Time Off',
      string005: 'Request Punctuality',
      string006: 'Request for Adjustment',
      string007: 'Overtime',
    },
    
    pontualidadeTeletex: {
      string001: 'Punctuality',
      string002: 'Start Date',
      string003: 'End Date',
      table01: {
        header01: 'Employee',
        header02: 'Competency',
        header03: 'Event',
        header04: 'Event name',
        header05: 'Value',
        header06: 'Hours',
        header07: 'Months',
      },
    },    
    denuncia: {
      string001: 'Report Channel',
      string002: 'How do you identify yourself?',
      string003: 'Victim"s name (If you want to identify)',
      string004: 'Informe o nome da vítima (Caso queira identificar)',
      string005: 'Offender"s name',
      string006: 'Enter the name of the offender',
      string007: 'The fact that will be reported is?',
      string008: 'When did it occur?',
      string009: 'Inform in detail when the event occurred',
      string010: 'Were there witnesses?',
      string011: 'Enter the name or names',
      string012: 'Enter the name or names of the people who witnessed the event',
      string013: 'Describe what happened',
      string014: 'Record as much information as possible, every detail counts',
      string015: 'Report recorded successfully!',      
    }
  },
};

export default ptBr;
